<template>
    <div class="QRcodeVideo">
        <!-- <div class="title">
            <p>漫步香山 · 共赏红叶</p>
            <p>蓝猫移动2024“一路同行”运动嘉年华</p>
        </div>
        <div class="video_con">
            <video ref="videoPlayer" controls :currentTime="currentTime" @timeupdate="updateCurrentTime">
                <source :src="videoSrc" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <input type="range" v-model="currentTime" :max="videoMaxTime">
        </div>


        <div class="btn">
            <van-button @click="play">播放</van-button>
            <van-button @click="pause">暂停</van-button>
        </div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            // videoSrc: require("../../assets/images/video/video_src.mp4"),
            // currentTime: 0,
            // videoMaxTime: 0,
        };
    },
    methods: {
        // play() {
        //     this.$refs.videoPlayer.play();
        // },
        // pause() {
        //     this.$refs.videoPlayer.pause();
        // },
        // updateCurrentTime() {
        //     this.currentTime = this.$refs.videoPlayer.currentTime;
        //     if (!this.videoMaxTime || this.videoMaxTime < this.$refs.videoPlayer.duration) {
        //         this.videoMaxTime = this.$refs.videoPlayer.duration;
        //     }
        // }
    }
};
</script>
<style lang="scss" scoped>
.QRcodeVideo {
    width: 100%;

    // .title {
    //     width: 100%;
    //     height: px2rem(130);
    //     display: flex;
    //     flex-direction: column;
    //     justify-content: space-around;
    //     align-items: center;
    //     font-size: px2rem(28);
    //     font-weight: 700;
    // }

    // .video_con {
    //     width: 100%;
    //     height: px2rem(600);
    //     // background: #336289;
    //     display: flex;
    //     justify-content: space-between;
    //     flex-direction: column;
    //     align-items: center;
    //     margin-top: px2rem(40);

    //     input {
    //         width: 100%;
    //     }

    //     video {
    //         width: 96%;
    //         height: 100%;
    //     }
    // }

    // .btn {
    //     width: 100%;
    //     height: px2rem(80);
    //     display: flex;
    //     justify-content: space-around;
    //     align-items: center;
    //     margin-top: px2rem(30);

    //     .van-button {
    //         width: 40%;
    //         height: px2rem(60);
    //         line-height: px2rem(80);
    //         color: #fff;
    //         font-weight: bold;
    //         font-size: px2rem(28);
    //         background-color: #336289;

    //     }
    // }
}
</style>